import * as React from "react";

/**
 * Handgezeichneter Pfeil.
 * Basisrichtung: von oben links nach unten rechts – über flipX/flipY drehbar.
 */
export const SketchArrow = ({
  className = "",
  flipX = false,
  flipY = false,
  tone = "light",
}) => (
  <svg
    aria-hidden
    viewBox="0 0 100 100"
    fill="none"
    className={`pointer-events-none absolute ${
      tone === "light" ? "text-[hsl(205_100%_68%)]" : "text-[hsl(222_85%_48%)]"
    } ${className}`}
    style={{ transform: `scale(${flipX ? -1 : 1}, ${flipY ? -1 : 1})` }}
  >
    <path
      d="M6 12 C 38 16, 58 34, 80 70"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
    <path
      d="M80 70 L 60 63 M80 70 L 76 48"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

/** Notiz in Handschrift – tone "light" für dunkle, "dark" für helle Flächen. */
export const HandNote = ({
  children,
  className = "",
  align = "left",
  tone = "light",
  fontSize = "clamp(11px, 4.4cqw, 32px)",
  absolute = true,
}) => (
  <span
    style={{ fontSize }}
    className={`pointer-events-none font-hand leading-[1.15] ${
      absolute ? "absolute" : "block"
    } ${
      tone === "light"
        ? "text-[hsl(203_100%_76%)] drop-shadow-[0_0_14px_hsl(205_100%_60%/0.45)]"
        : "text-[hsl(222_85%_44%)]"
    } ${align === "right" ? "text-right" : "text-left"} ${className}`}
  >
    {children}
  </span>
);
